import { Box, Button, Menu, MenuItem, MenuList, styled, TextField, Toolbar } from "@mui/material";
import { StyleguideSavioColors, MiscSavio } from "../../../../configuration/themeSettings";

export const ContentBox = styled(Box, { label: "code_and_description-content" })
    (({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        flex: 1,
        gap: "16px",
    }))

export const ContentBoxRow = styled(Box, { label: "code_and_description-row" })
    (({ theme }) => ({
        display: "flex",
        flex: 10,
        flexDirection: "row",
        gap: "10px",
        flexGrow: 10,
    }))

export const ApplicabilityListButton = styled(Button, { label: "code_and_description-button" })
    (({ theme }) => ({
        flexGrow: 1,
        width: 150,
        padding: 22,
        display: "flex",
        lineHeight: '14px',
    }))


export const MenuStyled = styled(Menu, { label: "code_and_description-menu-styled" })
    (({ theme }) => ({

        "> .MuiPopover-paper": {
            height: 400,
            borderBottomRightRadius: '4px !important',
            borderBottomLeftRadius: '4px !important',
            "> ul": {
                width: "400px !important",
                position: 'relative',
                "li": {
                    "div": {
                        textTransform: 'uppercase',
                        width: "100%",
                        whiteSpace: 'normal',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',

                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical'
                    }

                }

            }
        }
    }))

export const ToolbarStyled = styled(Toolbar, { label: "ToolbarStyled" })
    (({ theme }) => ({
        height: 55,
        minHeight: "auto !important",
        paddingLeft: 16 + "px !important",
        paddingRight: 16 + "px !important",
        backgroundColor: '#fff',
        width: "100%",
        position: 'sticky',
        zIndex: 1,
        top: 0,
    }));

export const SearchApplicabilities = styled(TextField, { label: "code_and_description-applicabilities" })
    (({ theme }) => ({
        width: "100%",
    }))

export const Li = styled(MenuItem, { label: "code_and_description-list-li" })
    (({ theme }) => ({
        borderBottom: '1px solid ' + StyleguideSavioColors.lighterGrey,
        "&:hover": {
            backgroundColor: MiscSavio.hoverBackgroundTable,
        }
    }))

    export const MenuListCustom = styled(MenuList, { label: "code_and_description-MenuListCustom" })
    (({ theme }) => ({
        "> li":{
            paddingLeft: 32,

            "a":{
                textDecoration: 'none',
            },

            "&:not(.selected)":{
                "&:hover":{
                    backgroundColor: 'inherit',
                    
                    "*":{textDecoration: 'underline',color: StyleguideSavioColors.blue,},
                    "&:before":{
                        display: 'block',
                        content: "''",
                        width: 3,
                        height: '100%',
                        backgroundColor: StyleguideSavioColors.blue ,
                        left:0,
                        position:'absolute',
                    }
                }
            }
        }
       
    }))